import {ActionLink} from 'shared/components';
import {FormattedMessage} from 'react-intl';

const ForgotPasswordLink = ({href = '/password_resets/new'}) => {
  return (
    <div className='h5 mt3 mb1 center'>
      <ActionLink onClick={() => window.location.href = href}>
        <FormattedMessage id='login.Forgot your password?'/>
      </ActionLink>
    </div>
  );
};

export default ForgotPasswordLink;
